// src/components/CompetitionDetailsView.js
import React, { useState, useEffect } from 'react';
import {
    Box,
    Tabs,
    Tab,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { getCompetitionDetails } from '../api/competitionApi';
import CompetitionInfo from './CompetitionInfo';
import CompetitionWorkouts from './CompetitionWorkouts';
import CompetitionLeaderboard from './CompetitionLeaderboard';
import CompetitionSchedule from './CompetitionSchedule';
import CompetitionJudges from './CompetitionJudges';

export default function CompetitionDetailsView({ competitionId, isAdminView, onClose }) {
    const [competition, setCompetition] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        loadCompetition();
    }, [competitionId]);

    const loadCompetition = async () => {
        try {
            setLoading(true);
            const data = await getCompetitionDetails(competitionId);
            setCompetition(data);
        } catch (error) {
            console.error('Error loading competition:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    if (loading) {
        return (
            <DialogContent>
                <Typography>Loading competition...</Typography>
            </DialogContent>
        );
    }

    if (!competition) {
        return (
            <DialogContent>
                <Typography>Competition not found</Typography>
            </DialogContent>
        );
    }

    return (
        <>
            <DialogTitle sx={{ pb: 1, position: 'relative', pr: 6 }}>
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8
                    }}
                >
                    <Close />
                </IconButton>
                <Typography variant="h6">
                    {competition.name}
                </Typography>
            </DialogTitle>

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                    <Tab label="Info" />
                    <Tab label="Workouts" />
                    <Tab label="Leaderboard" />
                    <Tab label="Schedule" />
                    {isAdminView && <Tab label="Judges" />}
                </Tabs>
            </Box>

            <DialogContent sx={{ px: { xs: 0, sm: 3 } }}>
                {activeTab === 0 && (
                    <CompetitionInfo
                        competition={competition}
                        isAdminView={isAdminView}
                        onUpdate={loadCompetition}
                    />
                )}
                {activeTab === 1 && (
                    <CompetitionWorkouts
                        competition={competition}
                        isAdminView={isAdminView}
                        onUpdate={loadCompetition}
                    />
                )}
                {activeTab === 2 && (
                    <CompetitionLeaderboard
                        competition={competition}
                        isAdminView={isAdminView}
                    />
                )}
                {activeTab === 3 && (
                    <CompetitionSchedule
                        competition={competition}
                        isAdminView={isAdminView}
                    />
                )}
                {isAdminView && activeTab === 4 && (
                    <CompetitionJudges
                        competitionId={competitionId}
                        isAdminView={isAdminView}
                        onUpdate={loadCompetition}
                    />
                )}
            </DialogContent>
        </>
    );
}